import React, { useState, useEffect } from "react";
import { Button, Typography, Stack, Box } from "@mui/material";
import DataTable from "../../components/DataTable";
import AddTagFrom from "./AddTagFrom";
import { useSearchParams } from "react-router-dom";
import { fetchTags, selectTagNumberOfPages, setTagsTableSettings, cleanTableSettings } from "../../redux/module/tag";
import useAppSelector from "../../hooks/useAppSelector";
import useAppDispatch from "../../hooks/useAppDispatch";
import tagTableColumns from "./tagTableColumns";
import { formatAgGridFilters, formatAgGridSorting } from "../../distflowAPI/common";
import PageLoading from "../../components/PageLoading";

const defaultColDef = {
  flex: 1,
  filter: true,
  floatingFilter: true,
};

const Tags = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { tags, pageSize, page, orderBy, filterBy, tagsLoading }= useAppSelector((state) => state.tag);
  const numberOfPages = useAppSelector(selectTagNumberOfPages);

  const [open, setOpen] = useState(false);


  useEffect(() => {
    dispatch(fetchTags({ page, pageSize, filterBy, orderBy }));
  }, [pageSize, page, filterBy, orderBy]);

  useEffect(() => {
    const params = new URLSearchParams();
    filterBy.forEach((item) => {
      params.set(item.column, item.value);
    });
    setSearchParams(params);
  }, [filterBy]);
  
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (field, value) => {
    if (field === "filterBy" || field === "pageSize") {
      dispatch(setTagsTableSettings({ field: "page", value: 1 }));
    }
    dispatch(setTagsTableSettings({ field, value }));
  };

  useEffect(() => {
    return () => {
      dispatch(cleanTableSettings())
    }
  }, []);
  
  return (
    <>
      <PageLoading dataLoading={tagsLoading} />

      <Typography fontSize="23px" fontWeight={800} component="h2" data-testid="page-title">
        Tags
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "space-between", sm: "center" }}
        justifyContent="space-between"
        spacing={1.5}
        my="25px"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing="15px"
        >
          <Button onClick={handleOpen} variant="contained">
            Add New
          </Button>
        </Stack>
      </Stack>

      <Box className="table-wrapper">
        <DataTable
          rowData={tags}
          columnDefs={tagTableColumns}
          defaultColDef={defaultColDef}
          suppressSorting={true} //disable default sorting
          loading={tagsLoading}
          rowHeight={53}
          headerHeight={60}
          onSortChanged={(event) =>
            handleChange("orderBy", formatAgGridSorting(event.columnApi.columnModel.gridColumns))
          }
          onFilterChanged={(event) =>
            handleChange("filterBy", formatAgGridFilters(event.api.getFilterModel()) || [])
          }
          page={page}
          pageSize={pageSize}
          setPageSize={(pageSize) => handleChange("pageSize", pageSize)}
          noPages={numberOfPages}
          setPage={(page) => handleChange("page", page)}
        />
      </Box>
      <AddTagFrom open={open} handleClose={handleClose} />
    </>
  );
};

export default Tags;
